/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'

export default {
  // addItem({ commit }, item) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/data-list/products/", {item: item})
  //       .then((response) => {
  //         commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  fetchBlogs ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('blogs/all')
        .then((response) => {
          commit('SET_BLOGS', response.data.data.blogs)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchBlog (context, blogId) {
    return new Promise((resolve, reject) => {
      axios.get(`blogs/${blogId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeBlog ({ commit }, blogId) {
    return new Promise((resolve, reject) => {
      axios.delete(`blogs/remove/${blogId}`)
        .then((response) => {
          commit('REMOVE_BLOG', blogId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateBlog ({dispatch}, blog) {
    return new Promise((resolve, reject) => {
      // console.log('updating blog')
      axios.put(`blogs/updateStatus/${blog.id}`, blog)
        .then((response) => {
          dispatch('fetchBlog')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
  // fetchBlogs ({ commit }) {
  //   return new Promise((resolve, reject) => {
  //     axios.get('/api/blogs/blogs')
  //       .then((response) => {
  //         commit('SET_BLOGS', response.data)
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  // fetchUser (context, userId) {
  //   return new Promise((resolve, reject) => {
  //     axios.get(`/api/blogs/blogs/${userId}`)
  //       .then((response) => {
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // }


}
